export default __webpack_public_path__ + "static/media/Ballroll_00037.db9c0627.png";